import { captureSession, sessionOwnerKey, type SessionOwner } from "./api/session";

const privateKeys = ["oransim_v3_prediction_draft", "oransim_v3_simulation_draft", "osim_last_predict",
  "oransim_v3_groupchat_overrides", "oransim_v3_recent_task_id", "oransim_v3_pending_operations"];

/** 捕获的旧身份是唯一清理目标；无归属记录及其他账户保持原样。 */
export function clearOwnedPrivateStorage(owner: SessionOwner): void {
  if (!owner || owner === "legacy") return;
  const suffix = sessionOwnerKey(owner);
  for (const key of privateKeys) {
    try { localStorage.removeItem(`${key}:${suffix}`); } catch { /* 浏览器拒绝存储时仍继续锁定并清空内存。 */ }
  }
}

/** Legacy key 原样保留；账户只读取自己的命名空间，锁屏期间禁止私有访问。 */
export function privateStorageKey(key: string): string {
  captureSession().assertCurrent();
  const owner = sessionOwnerKey();
  return owner === "legacy" ? key : `${key}:${owner}`;
}
export const privateStorage = {
  getItem(key: string): string | null { return localStorage.getItem(privateStorageKey(key)); },
  setItem(key: string, value: string): void { localStorage.setItem(privateStorageKey(key), value); },
  removeItem(key: string): void { localStorage.removeItem(privateStorageKey(key)); },
};
